import { SvgIcon } from "@mui/material";
import React from "react";

function ChervonDownIcon(props) {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <path
        d="M13.2797 5.93945L8.93306 10.2861C8.41973 10.7995 7.57973 10.7995 7.06639 10.2861L2.71973 5.93945"
        stroke="#757886"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default ChervonDownIcon;
